"use client";
import * as React from "react";

export const BgLayer = ({ children, color }: { children?: React.ReactNode; color?: string }) => (
  <div
    aria-hidden="true"
    className="absolute inset-0 pointer-events-none select-none overflow-hidden"
    style={color ? { background: color } : undefined}
  >
    {children}
  </div>
);

export const Drift = ({
  children, dx = 12, dy = 8, dur = 14, delay = 0, className = "",
}: {
  children: React.ReactNode; dx?: number; dy?: number; dur?: number; delay?: number; className?: string;
}) => (
  <div
    className={`absolute inset-0 pointer-events-none bg-drift ${className}`}
    style={{
      ["--bg-dx" as any]: `${dx}px`,
      ["--bg-dy" as any]: `${dy}px`,
      ["--bg-dur" as any]: `${dur}s`,
      ["--bg-delay" as any]: `${delay}s`,
    }}
  >
    {children}
  </div>
);

export const Pulse = ({
  children, scale = 1.05, dur = 9, delay = 0, className = "",
}: {
  children: React.ReactNode; scale?: number; dur?: number; delay?: number; className?: string;
}) => (
  <div
    className={`absolute inset-0 pointer-events-none bg-pulse ${className}`}
    style={{
      ["--bg-ps" as any]: scale,
      ["--bg-dur" as any]: `${dur}s`,
      ["--bg-delay" as any]: `${delay}s`,
    }}
  >
    {children}
  </div>
);

export const Star = ({
  x, y, size, color = "var(--color-primary)", opacity = 0.8,
}: { x: number; y: number; size: number; color?: string; opacity?: number }) => (
  <svg
    aria-hidden
    style={{ position: "absolute", left: `${x}%`, top: `${y}%`, width: size, height: size }}
    viewBox="0 0 24 24"
  >
    <path d="M12,2 L14,10 L22,12 L14,14 L12,22 L10,14 L2,12 L10,10 Z" style={{ fill: color }} opacity={opacity} />
  </svg>
);

export const DoodleStar = ({
  x, y, size, color = "var(--color-primary)", opacity = 0.85,
}: { x: number; y: number; size: number; color?: string; opacity?: number }) => (
  <svg
    aria-hidden
    style={{ position: "absolute", left: `${x}%`, top: `${y}%`, width: size, height: size }}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12,3 L13.5,10.5 L21,12 L13.5,13.5 L12,21 L10.5,13.5 L3,12 L10.5,10.5 Z"
      strokeWidth="1.5" strokeLinejoin="round"
      style={{ stroke: color, fill: color, fillOpacity: 0.2 }} opacity={opacity}
    />
  </svg>
);

export const DoodleSpark = ({
  x, y, size, color = "var(--color-primary)",
}: { x: number; y: number; size: number; color?: string }) => (
  <svg
    aria-hidden
    style={{ position: "absolute", left: `${x}%`, top: `${y}%`, width: size, height: size }}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12,2 L12,22 M2,12 L22,12 M5,5 L19,19 M19,5 L5,19"
      strokeWidth="1.5" strokeLinecap="round" opacity="0.65"
      style={{ stroke: color }}
    />
  </svg>
);

export const MeshBlob = ({
  left, top, width, height, color = "var(--color-primary)", opacity = 0.2,
}: { left: string; top: string; width: string; height: string; color?: string; opacity?: number }) => (
  <div
    aria-hidden
    style={{
      position: "absolute", left, top, width, height,
      background: `radial-gradient(closest-side, ${color}, transparent 70%)`,
      opacity, filter: "blur(20px)",
    }}
  />
);
